import React, { FC } from "react";
import { useIntl } from "react-intl";
import X2yNotifications from "../../X2y/implementations/X2yNotifications";
import NoFooterModal from "../NoFooterModal";

const User2NotificationsModal: FC<Props> = ({ isOpen, toggleOpen, userId }) => {
  const { formatMessage } = useIntl();

  return (
    <NoFooterModal
      toggle={toggleOpen}
      isOpen={isOpen}
      title={formatMessage({
        id: "settings.user2notif.assign_notif_to_user",
      })}
    >
      <X2yNotifications
        onSaveCallback={toggleOpen}
        placeholder={formatMessage({ id: "common.fulltext.search" })}
      />
    </NoFooterModal>
  );
};

export type Props = {
  userId: number;
  isOpen: boolean;
  toggleOpen: () => void;
};

export default User2NotificationsModal;
